import React from 'react'

const OrderPreparedPeykContainer = () => {
  return (
    <div>OrderPreparedPeykContainer</div>
  )
}

export default OrderPreparedPeykContainer